var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"material-class-statistics"},[_c('os-table',{attrs:{"tableOption":_vm.tableOptions,"tableColumnOption":_vm.columnOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }